import Cookies from 'js-cookie';

import eventBus from "@/shared/event-bus";

const ROLE_BUYER = 'C';
const ROLE_DESIGNER = 'D';

class RoleSwitcher
{
    switch(role)
    {
        Cookies.set('user_role', role, { expires: 365 });

        eventBus.emit('init_data_changed');
    }

    getRole() {
        return Cookies.get('user_role') ?? ROLE_BUYER;
    }

    isBuyer()
    {
        return this.getRole() === ROLE_BUYER;
    }

    isDesigner()
    {
        return this.getRole() === ROLE_DESIGNER;
    }
}

export default new RoleSwitcher();
